__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/7ab40e5d22117efbc952d7e76c02a574a9d5dca6/_next/";